import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PhoneFormComponent } from '@brightside/brightside-ui';
import { NotificationService } from '@brightside-web/desktop/data-access/shared';
import { BsHubService } from '@brightside-web/desktop/data-access/core-services';
import { ActivatedRoute, Router } from '@angular/router';
import * as libphonenumber from 'libphonenumber-js/max';

@Component({
  selector: 'brightside-web-get-the-app',
  templateUrl: './get-the-app.component.html',
  styleUrls: ['./get-the-app.component.scss']
})
export class GetTheAppComponent implements  AfterViewInit {
  @ViewChild('pfc') phoneForm: PhoneFormComponent;
  phoneFormIsValid$: Observable<boolean>;
  processing: boolean;

  constructor(
    private notSvc:NotificationService,
    private router:Router,
    private route:ActivatedRoute,
    private bsHubService: BsHubService) { }


  ngAfterViewInit(): void {
    const statusIsTrue = map(status => status === 'VALID');

    this.phoneFormIsValid$ = this.phoneForm.phoneForm.statusChanges.pipe(
      statusIsTrue
    );

  }

  getTheApp() {
    this.processing = true;
    this.notSvc.sendGetTheAppMessage(libphonenumber.parseDigits(this.phoneForm.phoneForm.controls['mobile'].value), window.navigator.userAgent).subscribe((resp)=>{
      if (resp.statusCode === 200){
        // send a message
        this.bsHubService.dispatch('OnboardingChannel', {event:'GetTheAppComplete', message: 'sent sms'});
        // route back to sign up
        this.router.navigate(['..','sign_up'], {relativeTo:this.route});
      }
      this.processing = false;
    })
  }
}
